module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }